import { render } from "./px-navbar-minimal.vue?vue&type=template&id=b7b04c1e&scoped=true&ts=true"
import script from "./px-navbar-minimal.vue?vue&type=script&lang=ts"
export * from "./px-navbar-minimal.vue?vue&type=script&lang=ts"

import "./px-navbar-minimal.vue?vue&type=style&index=0&id=b7b04c1e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b04c1e"]])

export default __exports__